import RatingStars from '~/components/molecules/Global/RatingStars.vue';
export default {
  name: 'Review',
  props: {
    stars: {
      type: Number,
      required: true
    },
    user: {
      type: String,
      required: true
    },
    experience: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      required: true
    }
  },
  components: {
    RatingStars
  }
};